import epg from "./epg"
import worker from "./worker"
import action from "./action"
import dvr from "./dvr"

class Services {
  constructor() {
    this.epg = epg
    this.worker = worker
    this.action = action
    this.dvr = dvr
  }
}

export default new Services()
